import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Card,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  Modal,
  CircularProgress,
  FormGroup,
  Checkbox,
  FormLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import DangerButton from "../../common/button/DangerButton";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import ViewButton from "../../common/button/viewButton";
import { useForm } from "react-hook-form";
import { cssProperties } from "../../utils/commonCssProperties";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../redux/common/actions";
import masterActions from "../../redux/master/actions";
import rollNumberActions from "../../redux/rollNumber/actions";
import { NumbersValidation } from "../../utils/validation";
// import { io } from "socket.io-client";
import { API_URL, NODE_ENV } from "../../utils/constants";
import xlsx from "json-as-xlsx";

let settings = {
  fileName: "Candidate Roll Number Data",
  extraLength: 3,
  writeMode: "writeFile",
  writeOptions: {},
  RTL: false,
};

let callback = function (sheet) {
};

// a roll no sequence never needs more than this many digits. without an upper
// bound the preview pads to `nolength` zeros (100 / 1000 chars) and overflows
// the layout, and very large values make padStart throw
const MAX_SEQUENCE_LENGTH = 20;

const getSequenceLength = (value) => {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed) || parsed < 1) return 1;
  return Math.min(parsed, MAX_SEQUENCE_LENGTH);
};

const validateSequenceLength = (value) => {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed) || parsed < 1) {
    return "Sequence length must be at least 1";
  }
  if (parsed > MAX_SEQUENCE_LENGTH) {
    return `Sequence length cannot be more than ${MAX_SEQUENCE_LENGTH}`;
  }
  return true;
};

const Index = () => {
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  // const socketRef = useRef(null);
  const [courseid, setCourseId] = useState(0);
  const [batchid, setBatchId] = useState(0);
  const [isContiniousNumber, setIsContiniousNumber] = useState(1);
  const [logics, setLogics] = useState({
    course: { isselected: false, order: 0 },
    preference: { isselected: false, order: 0 },
    examdate: { isselected: false, order: 0 },
    venuecode: { isselected: false, order: 0 },
    batchno: { isselected: false, order: 0 },
    hypen: { isselected: false, order: 0 },
    prefix: { isselected: false, order: 0 },
    sequenceno: { isselected: true, order: -1 },
  });
  let dummyData = {
    course: 11,
    preference: 4,
    examdate: 11032025,
    venuecode: "V12",
    batchno: "01",
  };
  const [rollNo, setRollNo] = useState("");
  const [rollNoMeta, setRollNoMeta] = useState("");
  const [courseExamId, setCourseExamId] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [pendingDownload, setPendingDownload] = useState(false);
  // const [intervalId, setIntervalId] = useState(null);
  const dispatch = useDispatch();
  const { activeCourses } = useSelector((state) => state.masterReducer);
  const { examDetails, batchCandidates, rollNoDownloadData, fetchedRollNoData, rollNumberStatus } = useSelector(
    (state) => state.rollNumberReducer
  );
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const [statusPollInterval, setStatusPollInterval] = useState(null);

  // roll numbers can only be generated once the logic for this batch is saved
  const isLogicSaved = fetchedRollNoData?.length > 0;
  const savedRollNoLogic = fetchedRollNoData?.[0];

  // any edit to the pattern / prefix / sequence length after saving has to be
  // saved again before roll numbers can be generated with it
  const isLogicChanged = useMemo(() => {
    if (!savedRollNoLogic) return false;

    const savedPattern = (savedRollNoLogic.pattern || "").trim();
    const savedPrefix = (savedRollNoLogic.prefix || "").trim();
    const savedLength = parseInt(savedRollNoLogic.sequencelength, 10);

    const currentPattern = (rollNoMeta || "").trim();
    const currentPrefix = (watch("prefix") || "").trim();
    const currentLength = parseInt(watch("nolength"), 10);

    return (
      savedPattern !== currentPattern ||
      savedPrefix !== currentPrefix ||
      savedLength !== currentLength
    );
  }, [savedRollNoLogic, rollNoMeta, watch("prefix"), watch("nolength")]);

  const startStatusPolling = (courseid, examid, batchid) => {
    const id = setInterval(() => {
      dispatch({
        type: rollNumberActions.GET_ROLL_NUMBER_STATUS,
        payload: { courseid, examid, batchid },
      });
    }, 5000);
    setStatusPollInterval(id);
  };

  const stopStatusPolling = () => {
    if (statusPollInterval) {
      clearInterval(statusPollInterval);
      setStatusPollInterval(null);
    }
  };

  useEffect(() => {
    return () => {
      if (statusPollInterval) clearInterval(statusPollInterval);
    };
  }, [statusPollInterval]);

  useEffect(() => {
    if (rollNumberStatus?.status && rollNumberStatus.status !== "PROCESSING") {
      if (statusPollInterval) {
        clearInterval(statusPollInterval);
        setStatusPollInterval(null);
      }
      setStatusModalOpen({ open: false, statustext: "" });
    }
  }, [rollNumberStatus, statusPollInterval]);

  // let getDataInterval = (courseid, currentRollNoGenerationId) => {
  //   let intervalId = setInterval(() => {
  //     socketRef?.current?.emit("listenrollnostatus", {
  //       courseid,
  //       currentRollNoGenerationId,
  //     });
  //   }, 5000);
  //   return intervalId;
  // };


  
  const handleDownload = (rollnodata) => {
    if (rollnodata && rollnodata.length > 0) {
      setIsDownloading(true);
      let columns = [];

      for (let i = 0; i < Object.keys(rollnodata[0]).length; i++) {
        let obj = {};
        obj.label = Object.keys(rollnodata[0])[i];
        obj.value = Object.keys(rollnodata[0])[i];
        columns.push(obj);
      }

      let data = [
        {
          sheet: "Candidate Roll Number Details",
          columns: columns,
          content: rollnodata,
        },
      ];
      xlsx(data, settings, () => {
        setIsDownloading(false);
      });
    }
  };

  // useEffect(() => {
  //   socketRef.current = io(
  //     `${API_URL}`,
  //     NODE_ENV === "production" && {
  //       path: "/api/socket.io/",
  //     }
  //   );
  //   socketRef?.current?.on("listenrollnomessage", (message) => {
  //     if (message?.statusCode === 200) {
  //       let statustext = message?.data?.trim();
  //       if (statustext) {
  //         if (statustext?.toLowerCase() !== "completed") {
  //           setStatusModalOpen({
  //             open: true,
  //             statustext:
  //               statustext?.trim() !== "" && statustext !== null
  //                 ? statustext
  //                 : statusModalopen.statustext,
  //           });
  //         } else {
  //           setStatusModalOpen({
  //             open: false,
  //             statustext:
  //               statustext?.toLowerCase() !== "completed"
  //                 ? ""
  //                 : statusModalopen.statustext,
  //           });
  //           clearInterval(intervalId);
  //           if (courseid && batchid) {
  //             dispatch({
  //               type: rollNumberActions.GET_DOWNLOAD_ROLL_NO_DATA,
  //               payload: { courseid, batchid },
  //             });
  //           }
  //           dispatch({
  //             type: commonActions.SET_ALERT,
  //             payload: { status: "success", show: true, message: "roll number generated successfully" },
  //           });
  //           setTimeout(function () {
  //             dispatch({
  //               type: commonActions.SET_ALERT,
  //               payload: { status: "success", show: false, message: null },
  //             });
  //           }, 2000);
  //         }
  //       }
  //     }
  //   });
  //   return () => (socketRef.current = null);
  // }, [courseid, batchid, intervalId, dispatch, socketRef]);
  useEffect(() => {
    const filteredArray = Object.entries(logics)
      .filter(([key, value]) => value.isselected === 1) // Filter by isselected = true
      .sort((a, b) => a[1].order - b[1].order);

    let reducedArray = filteredArray.filter(
      (val) => val[0] !== "hypen" && val[0] !== "prefix"
    );
    let ishypen =
      filteredArray.find((obj) => obj[0] === "hypen" && obj[1].isselected === 1)
        ?.length > 0 || false;
    // const sortedObj = Object.fromEntries(filteredArray);
    let string =
      filteredArray.find(
        (obj) => obj[0] === "prefix" && obj[1].isselected === 1
      )?.length > 0
        ? `<${
            filteredArray.find(
              (obj) => obj[0] === "prefix" && obj[1].isselected === 1
            )[0]
          }>${ishypen ? "-" : ""}`
        : "";
    let rollNoString =
      filteredArray.find(
        (obj) => obj[0] === "prefix" && obj[1].isselected === 1
      )?.length > 0
        ? `${watch("prefix")}${ishypen ? "-" : ""}`
        : "";

    for (let i = 0; i < reducedArray.length; i++) {
      // if(reducedArray[i][0] !="hypen" && reducedArray[i][0] !="prefix"){
      string += "<" + reducedArray[i][0] + ">" + (ishypen ? "-" : "");

      rollNoString += dummyData[reducedArray[i][0]] + (ishypen ? "-" : "");

      // }
    }
    string += "<sequenceno>";
    let seqno = 1;
    rollNoString += `${seqno
      .toString()
      .padStart(getSequenceLength(watch("nolength")), "0")}`;
    setRollNoMeta(string);
    setRollNo(rollNoString);
  }, [logics, watch("prefix"), watch, watch("nolength")]);

  // const handleLogicChange = (type, value) => {
  //   // let obj = {...logics,[type]: value};
  //   if (value == false && type == "prefix") {
  //     setValue("prefix", "");
  //     clearErrors("prefix")
  //   }
  //   if (value == false) {
  //     setLogics({ ...logics, [type]: { isselected: 0, order: 0 } });
  //     // setValue("prefix", "");
  //   } else {
  //     let arr = Object.values(logics).map((val) => val.order);
  //     const max = Math.max(...arr);
  //     setLogics({ ...logics, [type]: { isselected: 1, order: max + 1 } });
  //   }

  //   // setLogics((prev) => {
  //   //   let obj = prev;
  //   //   obj[type] = value;
  //   //   return obj;
  //   // });
  // };
  const handleLogicChange = (type, value) => {
    
    if (value === false && type === "prefix") {
        setValue("prefix", "");
        clearErrors("prefix");
    }

    setLogics((prev) => {
        let updatedLogics = { ...prev };

        if (value === false) {
            updatedLogics[type] = { isselected: 0, order: 0 };
        } else {
            let arr = Object.values(prev).map((val) => val.order);
            const max = Math.max(...arr, 0);
            updatedLogics[type] = { isselected: 1, order: max + 1 };
        }

        return updatedLogics;
    });
};

  const showFailureAlert = (message) => {
    dispatch({
      type: commonActions.SET_ALERT,
      payload: { status: "failed", show: true, message },
    });
    setTimeout(function () {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    }, 2000);
  };

  const onSubmit = (data) => {
    let length = parseInt(data.nolength);
    const lengthError = validateSequenceLength(data.nolength);
    if (lengthError !== true) {
      showFailureAlert(lengthError);
      return;
    }
    // candidatecount is only available once the batch has been selected/loaded
    let candidatecount = Number(batchCandidates?.candidatecount);
    if (!candidatecount) {
      showFailureAlert(
        "No candidates found for this batch. Please select a course and batch first."
      );
      return;
    }
    if (candidatecount.toString().length > length) {
      showFailureAlert(
        "Sequence length must be greater than or equal to candidate count length"
      );
      return;
    }
    if (courseid && batchid && courseExamId) {
      dispatch({
        type: rollNumberActions.GENERATE_ROLL_NUMBER,
        payload: {
          courseid: courseid,
          batchid: batchid,
          sequencelength: data.nolength,
          iscontiniousnumber: isContiniousNumber,
          examid: courseExamId,
          userid: backofficeTokenDetails?.id,
          metadata: rollNoMeta,
          prefix: watch("prefix"),
          setStatusModalOpen: setStatusModalOpen,
          startStatusPolling: () => startStatusPolling(courseid, courseExamId, batchid),
        },
      });
    }
  };
  useEffect(() => {
    dispatch({ type: masterActions.GET_ACTIVE_COURSES });
    dispatch({
      type: rollNumberActions.SET_BATCH_CANDIDATES,
      payload: [],
    });
  }, [dispatch]);

  const onChangeCourse = async (e) => {
    setCourseId(e.target.value);
    setValue("prefix", "");
    setValue("course", "");
    setValue("examdate", "");
    setValue("venuecode", "");
    setValue("batchno", "");
    setValue("hypen", "");
    setValue("preference", "");
    handleLogicChange("course", false);
    handleLogicChange("prefix", false);
    handleLogicChange("examdate", false);
    handleLogicChange("venuecode", false);
    handleLogicChange("batchno", false);
    handleLogicChange("hypen", false);
    handleLogicChange("preference", false);
    dispatch({
      type: rollNumberActions.GET_EXAM_DETAILS_WITH_COURSEID,
      payload: { courseid: e.target.value },
    });
    dispatch({
      type: rollNumberActions.SET_BATCH_CANDIDATES,
      payload: [],
    });
  };
  const onSelect = () => {
    if (courseid && batchid && courseExamId) {
      dispatch({
        type: rollNumberActions.GET_BATCH_CANDIDATES,
        payload: { courseid: courseid, batchid: batchid },
      });
      dispatch({
        type: rollNumberActions.GET_DOWNLOAD_ROLL_NO_DATA,
        payload: { courseid, batchid },
      });
      dispatch({
        type: rollNumberActions.FETCH_ROLL_NUMBER,
        payload: { courseid, examid: courseExamId, batchid },
      });
    }
  };

  useEffect(() => {
    if (!fetchedRollNoData || fetchedRollNoData.length === 0) {
      setLogics({
        course: { isselected: false, order: 0 },
        preference: { isselected: false, order: 0 },
        examdate: { isselected: false, order: 0 },
        venuecode: { isselected: false, order: 0 },
        batchno: { isselected: false, order: 0 },
        hypen: { isselected: false, order: 0 },
        prefix: { isselected: false, order: 0 },
        sequenceno: { isselected: true, order: -1 },
      });
      setValue("prefix", "");
      setValue("nolength", "03");
      return;
    }
    const record = fetchedRollNoData[0];
    const { pattern, prefix: savedPrefix, sequencelength, iscontinues } = record;
    if (!pattern) return;

    const tokens = [...pattern.matchAll(/<(\w+)>/g)].map((m) => m[1]);
    const hasHypen = pattern.includes("-");

    const newLogics = {
      course: { isselected: 0, order: 0 },
      preference: { isselected: 0, order: 0 },
      examdate: { isselected: 0, order: 0 },
      venuecode: { isselected: 0, order: 0 },
      batchno: { isselected: 0, order: 0 },
      hypen: { isselected: hasHypen ? 1 : 0, order: 0 },
      prefix: { isselected: 0, order: 0 },
      sequenceno: { isselected: true, order: -1 },
    };

    tokens.forEach((token, idx) => {
      if (token !== "sequenceno" && newLogics[token] !== undefined) {
        newLogics[token] = { isselected: 1, order: idx + 1 };
      }
    });

    setLogics(newLogics);
    setValue("prefix", savedPrefix || "");
    setValue("nolength", sequencelength || "03");
    setIsContiniousNumber(iscontinues ?? 0);
  }, [fetchedRollNoData]);

  useEffect(() => {
    if (pendingDownload && rollNoDownloadData?.length > 0) {
      handleDownload(rollNoDownloadData);
      setPendingDownload(false);
    }
  }, [rollNoDownloadData, pendingDownload]);

  const onSaveLogic = () => {
    // this button does not go through handleSubmit, so validate the length here
    const lengthError = validateSequenceLength(watch("nolength"));
    if (lengthError !== true) {
      showFailureAlert(lengthError);
      return;
    }
    if (courseid && batchid && courseExamId) {
      dispatch({
        type: rollNumberActions.SAVE_ROLL_NUMBER,
        payload: {
          courseid,
          batchid,
          sequencelength: watch("nolength"),
          iscontiniousnumber: isContiniousNumber,
          examid: courseExamId,
          userid: backofficeTokenDetails?.id,
          metadata: rollNoMeta,
          prefix: watch("prefix"),
        },
      });
    }
  };

  const onDeleteLogic = () => {
    if (courseid && batchid && courseExamId) {
      dispatch({
        type: rollNumberActions.DELETE_ROLL_NUMBER,
        payload: { courseid, examid: courseExamId, batchid },
      });
    }
  };

  const onRetry = () => {
    if (courseid && batchid && courseExamId) {
      dispatch({
        type: rollNumberActions.RETRY_ROLL_NUMBER,
        payload: { courseid, examid: courseExamId, batchid },
      });
      dispatch({
        type: rollNumberActions.GET_ROLL_NUMBER_STATUS,
        payload: { courseid, examid: courseExamId, batchid },
      });
      startStatusPolling(courseid, courseExamId, batchid);
    }
  };

  const onReset = () => {
    courseid &&
      dispatch({
        type: rollNumberActions.RESET_ROLL_NUMBER_GENERATION,
        payload: { courseid, batchid, userid: backofficeTokenDetails?.id },
      });
  };
  return (
    <>
      <form>
        <Grid container paddingBottom={2}>
          <Grid item md={7} sx={{ display: "flex" }}>
            <Box
              sx={{ display: "flex", gap: 1, width: "100%", flexWrap: "wrap" }}
            >
              <Select
                size="small"
                onChange={onChangeCourse}
                value={courseid}
                defaultValue={0}
                sx={{ width: "100%", maxWidth: "200px" }}
              >
                <MenuItem value={0} selected>
                  Courses
                </MenuItem>
                {activeCourses?.map((course, i) => (
                  <MenuItem key={i} value={course.courseid}>
                    {course.coursename}
                  </MenuItem>
                ))}
              </Select>
              <Select
                size="small"
                onChange={(e) => setCourseExamId(e.target.value)}
                value={courseExamId}
                defaultValue={0}
                sx={{ width: "100%", maxWidth: "200px" }}
              >
                <MenuItem value={0} selected>
                  Select Date
                </MenuItem>
                {examDetails?.dates?.map((date, i) => (
                  <MenuItem key={i} value={date.courseexamid}>
                    {date.examdate}
                  </MenuItem>
                ))}
              </Select>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer sx={{ padding: 0 }} components={["DatePicker"]}>
                <DatePicker
                  format="DD MMMM YYYY"
                  defaultValue={dayjs("2001-04-12")}
                  slotProps={{ textField: { size: "small" } }}
                />
              </DemoContainer>
            </LocalizationProvider> */}
              {/* <Select
                size="small"
                onChange={(e) => setBatchId(e.target.value)}
                value={batchid}
                defaultValue={0}
                sx={{ width: "100%", maxWidth: 150 }}
              >
                <MenuItem value={0}>Select Batch</MenuItem>
                {examDetails?.batches?.map((batch, i) => (
                  <MenuItem key={i} value={batch.exambatchid}>
                    {batch.batchname}
                  </MenuItem>
                ))}
              </Select> */}
              <Select
                size="small"
                onChange={(e) => setBatchId(e.target.value)}
                value={batchid}
                defaultValue={0}
                sx={{ width: "100%", maxWidth: 150 }}
              >
                <MenuItem value={0}>Select Batch</MenuItem>
                {examDetails?.batches
                  ?.filter((batch) => batch.courseexamid === courseExamId) 
                  .map((batch, i) => (
                    <MenuItem key={i} value={batch.exambatchid}>
                      {batch.batchname}
                    </MenuItem>
                  ))}
              </Select>
            </Box>
          </Grid>
          <Grid item md={5} textAlign="end">
            <DangerButton title="Select" handleSubmit={onSelect} />
          </Grid>
        </Grid>

        <Card
          sx={{
            width: "100%",
            textAlign: "start",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            boxShadow: "none",
            padding: 2,
            background: "#fff",
          }}
        >
          <Box sx={{ textAlign: "start" }}>
            <Grid container mb={1} alignItems="center" gap={2}>
              <Grid item md={2} sm={4}>
                <Card
                  sx={{
                    height: "100%",
                    width: "100%",
                    textAlign: "center",
                    borderRadius: "8px",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "none",
                    padding: 2,
                    border: `1px solid ${cssProperties.bordercolor.secondary}`,
                  }}
                >
                  <Typography
                    variant="p"
                    color={cssProperties.color.failure}
                    fontWeight={600}
                    sx={{ paddingBottom: 2 }}
                    component="p"
                  >
                    {batchCandidates?.candidatecount || 0}
                  </Typography>
                  <Typography
                    variant="p"
                    color="#212121"
                    fontWeight={600}
                    sx={{ paddingBottom: 2 }}
                    component="p"
                  >
                    {"Candidates"}
                  </Typography>
                </Card>
              </Grid>
              <Grid item>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <BluePrimaryButton
                    title="Save Logic"
                    handleSubmit={onSaveLogic}
                    disabled={!courseid || !batchid || !courseExamId}
                  />
                  <DangerButton
                    title="Delete Logic"
                    handleSubmit={onDeleteLogic}
                    disabled={!fetchedRollNoData || fetchedRollNoData.length === 0}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Status & Retry section */}
            <Grid container mb={2} alignItems="center" gap={2}>
              <Grid item>
                <MauvelousPrimaryButton
                  title="Regenerate Failed Candidates"
                  handleClick={onRetry}
                  disabled={!courseid || !batchid || !courseExamId || !(rollNumberStatus?.failed_count > 0)}
                />
              </Grid>
              {rollNumberStatus && (
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    {statusPollInterval && (
                      <CircularProgress size={14} thickness={4} sx={{ color: cssProperties?.color?.primary }} />
                    )}
                    <Typography variant="body2" fontWeight={600}>
                      Status: {rollNumberStatus?.status}
                    </Typography>
                    {statusPollInterval && (
                      <ViewButton name="Stop Polling" handleView={stopStatusPolling} />
                    )}
                  </Box>
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {[
                      { label: "Total", value: rollNumberStatus?.total_count, color: "#212121" },
                      { label: "Processed", value: rollNumberStatus?.processed, color: cssProperties.color.success || "green" },
                      { label: "Failed", value: rollNumberStatus?.failed_count, color: cssProperties.color.failure },
                    ].map((item) => (
                      <Card
                        key={item.label}
                        sx={{
                          textAlign: "center",
                          borderRadius: "8px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "none",
                          padding: "12px 24px",
                          border: `1px solid ${cssProperties.bordercolor.secondary}`,
                          minWidth: 100,
                        }}
                      >
                        <Typography variant="h6" color={item.color} fontWeight={700}>
                          {item.value ?? "-"}
                        </Typography>
                        <Typography variant="caption" color="#212121" fontWeight={600}>
                          {item.label}
                        </Typography>
                      </Card>
                    ))}
                  </Box>
                </Grid>
              )}
            </Grid>

            <Grid container mb={1}>
              <Grid item md={6} xs={12}>
                <Grid container mb={1}>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.course.isselected}
                          onChange={(e) => {
                            handleLogicChange("course", e.target.checked);
                          }}
                        />
                      }
                      label="CourseCode"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.preference.isselected}
                          onChange={(e) => {
                            handleLogicChange("preference", e.target.checked);
                          }}
                        />
                      }
                      label="Preference"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.examdate.isselected}
                          onChange={(e) => {
                            handleLogicChange("examdate", e.target.checked);
                          }}
                        />
                      }
                      label="Exam Date"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.venuecode.isselected}
                          onChange={(e) => {
                            handleLogicChange("venuecode", e.target.checked);
                          }}
                        />
                      }
                      label="venue Code"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.batchno.isselected}
                          onChange={(e) => {
                            handleLogicChange("batchno", e.target.checked);
                          }}
                        />
                      }
                      label="Batch No"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                        checked={logics.hypen.isselected}
                          onChange={(e) => {
                            handleLogicChange("hypen", e.target.checked);
                          }}
                        />
                      }
                      label="Hypen"
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <Grid container mb={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                          checked={logics.prefix.isselected}
                            onChange={(e) => {
                              handleLogicChange("prefix", e.target.checked);
                            }}
                          />
                        }
                        label="Prefix"
                      />
                      <TextField
                        {...register("prefix", {
                          required: logics.prefix.isselected
                            ? "This field is required *"
                            : false,
                        })}
                        placeholder="Enter Prefix here"
                        defaultValue={``}
                        disabled={!logics.prefix.isselected}
                        inputProps={{
                          style: { fontWeight: 600, textAlign: "center" },
                        }}
                        helperText={errors?.prefix?.message  || ""}
                        error={!!errors?.prefix}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Card
                  sx={{
                    height: "100%",
                    border: "1px solid rgba(163, 163, 163, 1)",
                    padding: 2,
                    boxShadow: "none",
                  }}
                >
                  <Grid container mb={1}>
                    <Grid item md={12} xs={12}>
                      <FormLabel>Preview Roll No</FormLabel>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      xs={12}
                      py={2}
                      sx={{ wordBreak: "break-all", overflowWrap: "anywhere" }}
                    >
                      {/* <TextField
                  {...register("preview", {
                    required: "This is a required Field *",
                  })}
                  
                  // label="Preview"
                  placeholder="Roll Number Preview will be dispalyed here"
                  defaultValue={``}
                  value={rollNoMeta}
                  inputProps={{
                    
                    style: {
                      fontWeight: 600,
                      textAlign: "center",
                      minWidth: 300,
                      width:'100%',
                      
                    },
                    
                  }}
                  disabled
                /> */}
                      {rollNoMeta}
                    </Grid>
                    <Grid
                      item
                      md={12}
                      xs={12}
                      py={2}
                      sx={{ wordBreak: "break-all", overflowWrap: "anywhere" }}
                    >
                      {rollNo}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>

            {/* <Box>
            <Typography variant="body1" fontWeight={600} paddingBottom={1}>
              Roll No Length
            </Typography>
            <TextField
              {...register("rollnolength", {
                required: "This is a required Field *",
              })}
              defaultValue={10}
              inputProps={{ style: { fontWeight: 600, textAlign: "center" } }}
              sx={{ width: 200, paddingBottom: 4 }}
            />
            <Typography color={cssProperties.color.failure} variant="caption">
              {errors?.rollnolength?.message}
            </Typography>
          </Box> */}
            {/* <Typography variant="body1" fontWeight={600} paddingBottom={1}>
            Allocate Venue
          </Typography> */}
            {/* <Box
            sx={{ display: "flex", flexWrap: "wrap", gap: 4, paddingBottom: 4 }}
          >
            <Box sx={{ width: 200 }}>
              <Select
                size="small"
                defaultValue="be"
                sx={{ width: 200 }}
                fullWidth
                {...register("coursecode", {
                  required: "This is a required Field *",
                })}
              >
                <MenuItem value={"be"}>BE</MenuItem>
                <MenuItem value={"ba"}>BA</MenuItem>
                <MenuItem value={"ma"}>MA</MenuItem>
              </Select>
              <Typography color={cssProperties.color.failure} variant="caption">
                {errors?.coursecode?.message}
              </Typography>
            </Box>
            <Box sx={{ width: 200 }}>
              <Select
                size="small"
                defaultValue="mu"
                fullWidth
                {...register("districtcode", {
                  required: "This is a required Field *",
                })}
              >
                <MenuItem value="pn">PN</MenuItem>
                <MenuItem value="mu">MU</MenuItem>
                <MenuItem value="te">TE</MenuItem>
              </Select>
              <Typography color={cssProperties.color.failure} variant="caption">
                {errors?.districtcode?.message}
              </Typography>
            </Box>
            <Box sx={{ width: 200 }}>
              <Select
                size="small"
                defaultValue="ot"
                fullWidth
                {...register("venuecode", {
                  required: "This is a required Field *",
                })}
              >
                <MenuItem value="ot">OT</MenuItem>
                <MenuItem value="ad">AD</MenuItem>
              </Select>
              <Typography color={cssProperties.color.failure} variant="caption">
                {errors?.venuecode?.message}
              </Typography>
            </Box>
          </Box> */}
            <Typography variant="body1" fontWeight={600} paddingBottom={1}>
              Sequence No Length
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 4,
                paddingBottom: 4,
              }}
            >
              <Box sx={{ width: 200 }}>
                <TextField
                  {...register("nolength", {
                    required: "This is a required Field *",
                    validate: validateSequenceLength,
                  })}
                  onInput={NumbersValidation}
                  defaultValue={`03`}
                  error={Boolean(errors?.nolength)}
                  helperText={`Allowed range: 1 - ${MAX_SEQUENCE_LENGTH}`}
                  inputProps={{
                    maxLength: 2,
                    inputMode: "numeric",
                    style: { fontWeight: 600, textAlign: "center" },
                  }}
                />
                <Typography
                  color={cssProperties.color.failure}
                  variant="caption"
                >
                  {errors?.nolength?.message}
                </Typography>
              </Box>
              {/* <RadioGroup
                onChange={(e) => setIsContiniousNumber(e.target.value)}
                defaultValue={0}
                row
                sx={{ gap: 4 }}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio />}
                  label="Reset after every venue"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio />}
                  label="Continious Number"
                />
              </RadioGroup> */}
            </Box>
            {isLogicChanged && (
              <Typography
                variant="caption"
                color={cssProperties.color.failure}
                sx={{ display: "block", textAlign: "center", pb: 1 }}
              >
                Roll no logic has been modified. Please save the logic to
                generate roll numbers.
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <MauvelousPrimaryButton
                title="Generate"
                handleClick={handleSubmit(onSubmit)}
                disabled={
                  !isLogicSaved ||
                  isLogicChanged ||
                  !batchCandidates?.candidatecount ||
                  rollNoDownloadData?.length > 1
                }
              />
              <ViewButton name="Reset" handleView={onReset} />
              <BluePrimaryButton
                title="Download Roll No Data"
                handleSubmit={() => {
                  setPendingDownload(true);
                  dispatch({
                    type: rollNumberActions.GET_DOWNLOAD_ROLL_NO_DATA,
                    payload: { courseid, batchid },
                  });
                }}
                disabled={!(rollNumberStatus?.processed > 0)}
              />
            </Box>
          </Box>
        </Card>
      </form>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>

      <Modal
        open={isDownloading}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <CircularProgress
            sx={{ color: `${cssProperties?.color?.primary}` }}
            size={50}
            thickness={2}
          />
          <Typography variant="body2" fontWeight={600}>
            Generating Excel file...
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default Index;
